module.exports = __webpack_public_path__ + "media/images/icons/pen-ruler-487257251a483215992c06f41987d154.svg";